import { styled } from 'stitches.config'
import { Button } from 'components/Button'

export const CommentsRoot = styled('div', {
  width: '100%',
  maxWidth: '1400px',
  margin: 'auto',
  marginTop: '60px',
  padding: '0px 24px',

  '& .desktop-only': {
    display: 'none',
  },
  '& .mobile-only': {
    display: 'block',
  },

  '@bp3': {
    '& .desktop-only': {
      display: 'flex',
    },
    '& .mobile-only': {
      display: 'none',
    },
  },
})

export const ReviewCardWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  background: '$accent-white',
  borderRadius: '20px',
  border: '1px solid $accent-gray',
  padding: '28px',
  
  minHeight: 'none',
  width: '100%',
  maxWidth: '360px',

  '@bp3': {
    minHeight: '380px',
    maxWidth: '380px',
  }
})

export const RatingWrapper = styled('div', {
  '& > div': {
    marginLeft: 0,
    marginTop: '12px',
    marginBottom: '24px',
  },
})

export const ReviewColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '$5',
})

export const ReviewGrid = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: '$5',
})

export const TagButton = styled('button', {
  fontSize: '$body',
  backgroundColor: '$transparent',
  padding: '20px 24px',
  color: '$accent-black',
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: '$accent-gray',
  borderRadius: '$pill',
  fontFamily: '$primary',
  transition: 'all 0.5s ease',

  '&:hover, &:focus': {
    borderColor: '$primary-500',
    backgroundColor: '$tertiary-200',
  },

  '&:first-child': {
    padding: '20px 40px',
  },

  variants: {
    active: {
      true: {
        borderColor: '$primary-500',
        backgroundColor: '$tertiary-200',
      },
    },
  },
})
